import { getTranslations } from "@/lib/translations";

import { requireStaffMemberId } from "@/core/auth/admin-guard";
import { createArticleService } from "@/core/services/factory";
import { getArticleSharePath } from "@/core/services/types/article.types";

export async function createArticleAction(
  input: { title?: string } = {},
): Promise<{ redirectTo: string }> {
  const assignedTo = await requireStaffMemberId();

  const t = getTranslations("articles.library");
  const result = await createArticleService().createArticle({
    ...(input.title ? { title: input.title.trim() } : {}),
    assignedTo,
  });

  if (!result.success) {
    throw new Error(t("createFailed"));
  }

  return { redirectTo: getArticleSharePath(result.data.id) };
}

export async function createArticleQuickAddAction(input: {
  title: string;
}): Promise<void> {
  const assignedTo = await requireStaffMemberId();

  const t = getTranslations("articles.library");
  const result = await createArticleService().createArticle({
    title: input.title.trim(),
    status: "SIGNAL",
    assignedTo,
  });

  if (!result.success) {
    throw new Error(
      result.error === "signal_status_failed"
        ? t("createSignalFailed")
        : t("createFailed"),
    );
  }
}
